import React, { lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// import PublicLayout from "./layouts/public-layout.component";
import { dashboardRoutes, publicRoutes } from "./routes";
import DashboardLayout from "./layouts/dashboard.layout";
import PublicLayout from "./layouts/public.layout";
import PrivateRoute from "./layouts/private-route.component";
import PublicRoute from "./layouts/public-route.component";
import { useSelector } from "react-redux";

const SignInComponent = lazy(() => import("./pages/public/signin"));
const RegisterComponent = lazy(() => import("./pages/public/register"));
const ForgotPasswordComponent = lazy(() =>
  import("./pages/public/passwordResetPhoneNumber")
);
const PasswordResetFormComponent = lazy(() =>
  import("./pages/public/passwordResetForm")
);
const VerifyOTPComponent = lazy(() =>
  import("./pages/public/passwordResetVerification")
);
const VerifyToken = lazy(() => import("./pages/public/verifyToken"));
const NotFound = lazy(() => import("./components/not-found.component"));

const WebRoutes = () => {
  const userRole = useSelector(({ auth }) => auth.userRole);

  // The routes accessible by everyone
  let allRoutes = [dashboardRoutes["all"]];

  // Add all accessible routes by role
  Array.isArray(userRole) &&
    userRole.map((role) => role && allRoutes.push(dashboardRoutes[role]));

  // Filter the allroutes array to get all the routes with the user layout
  const userRoutes = allRoutes.flat().filter((route) => {
    return route.layout === "/user";
  });

  // Filter the allroutes array to get all the routes with the admin layout
  const adminRoutes = allRoutes.flat().filter((route) => {
    return route.layout === "/admin";
  });

  // Display the user routes using the Dashboard layout created
  const UserPages = () => {
    return <DashboardLayout>{userRoutes}</DashboardLayout>;
  };

  // Display the admin routes using the Dashboard layout created
  const AdminPages = () => {
    return <DashboardLayout>{adminRoutes}</DashboardLayout>;
  };

  const PublicPages = () => {
    return <PublicLayout>{publicRoutes}</PublicLayout>;
  };

  return (
    <Switch>
      <Route exact path="/login" component={SignInComponent} />
      <Route exact component={ForgotPasswordComponent} path="/forgot-pass" />
      <Route exact component={RegisterComponent} path="/register" />
      <Route
        exact
        component={PasswordResetFormComponent}
        path="/reset-password"
      />
      <Route exact component={VerifyOTPComponent} path="/verify" />
      <Route exact component={VerifyToken} path="/verify-token" />
      <Route exact component={NotFound} path="/404" />
      <PrivateRoute userRole={userRole} component={AdminPages} path="/admin" />
      <PrivateRoute userRole={userRole} component={UserPages} path="/user" />
      <PublicRoute component={PublicPages} path="/" />
      <Redirect to="/404" />
    </Switch>
  );
};

export default WebRoutes;

// Note

/* 
The flat() method creates a new array with all sub-array elements concatenated into it recursively up to the specified depth.
syntax 
flat()
flat(depth)

const arr1 = [0, 1, 2, [3, 4]];

// expected output: [0, 1, 2, 3, 4]

const arr2 = [0, 1, 2, [[[3, 4]]]];

// expected output: [0, 1, 2, [3, 4]]

const arr4 = [1, 2, [3, 4, [5, 6, [7, 8, [9, 10]]]]];
arr4.flat(Infinity);
*/
